import {
	Alert,
	Box,
	Button,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	FormLabel,
	Grid,
	Modal,
	Radio,
	TextField,
	Typography,
	Switch,
} from "@mui/material";
import { uploadFileSimulation, auditPost } from "../../api/config";
import { FormNameDesc } from "./FormNameDesc";
import Swal from "sweetalert2";
import { useState, useContext } from "react";
import { GlobalContext } from "../../GlobalContext";
import { useTranslation } from "react-i18next";

const ModalFechaUpload = ({ open, onClose, selectedIdArea }) => {
	const { t } = useTranslation();
	const { getModuleId } = useContext(GlobalContext);
	const [fechaFin, setFechaFin] = useState("");
	const [fechaInicio, setFechaInicio] = useState("");
	const [fechaError, setFechaError] = useState("");
	const [checkedError, setCheckedError] = useState("");
	const [checked, setChecked] = useState("");
	const [selectedFile, setSelectedFile] = useState(null);
	const [formValues, setFormValues] = useState({
		name: "",
		description: "",
	});
	const [formErrors, setFormErrors] = useState({
		name: false,
		description: false,
	});
	const [emailNotifications, setEmailNotifications] = useState(false);
	const [showAlert, setShowAlert] = useState(false);

	const handleFormChange = (name, value) => {
		setFormValues({
			...formValues,
			[name]: value,
		});
		setFormErrors({
			...formErrors,
			[name]: false,
		});
	};
	const pasteYearMonth = (date) => {
		const [year, month] = date.split("-");
		return { year: parseInt(year, 10), month: parseInt(month, 10) };
	};
	const handleButtonClick = async () => {
		const errors = {
			name: formValues.name.trim() === "",
			description: formValues.description.trim() === "",
		};

		setFormErrors(errors);

		if (!fechaInicio || !fechaFin) {
			setFechaError(t("aux.messages.date_obligatory"));
			return;
		} else {
			const inicio = pasteYearMonth(fechaInicio);
			const fin = pasteYearMonth(fechaFin);

			const inicioTotal = inicio.year * 12 + inicio.month;
			const finTotal = fin.year * 12 + fin.month;
			if (inicioTotal > finTotal) {
				setFechaError(t("aux.messages.date_error"));
				return;
			} else {
				setFechaError("");
			}
		}

		if (!checked) {
			setCheckedError(t("aux.messages.select_checkbox"));
			return;
		} else {
			setCheckedError("");
		}

		if (errors.name || errors.description) {
			setShowAlert(true);
			return;
		} else {
			setShowAlert(false);
		}

		setFechaFin("");
		setFechaInicio("");
		setChecked("");
		setEmailNotifications(false);
		setFormValues({
			name: "",
			description: "",
		});
		onClose();

		const data = {
			site_id: selectedIdArea,
			name: formValues.name,
			description: formValues.description,
			start: fechaInicio,
			end: fechaFin,
			send_mail: emailNotifications,
			forecast_origin: checked,
		};

		if (selectedFile && data) {
			Swal.fire({
				title: t("aux.messages.sure"),
				text: t("aux.messages.sure_file"),
				icon: "question",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: t("aux.buttons.yes"),
			}).then((result) => {
				if (result.isConfirmed) {
					uploadFileSimulation(`/launch_w_params`, data, selectedFile);
					const moduleId = getModuleId("Simulación", "Ejecutar desde archivo");
					auditPost(moduleId, selectedIdArea)
						.then(() => {
							Swal.fire({
								title: t("aux.messages.alert.success"),
								text: t("aux.messages.alert.text_alert.send_file"),
								icon: "success",
							});
						})
						.catch((error) => {
							Swal.fire({
								title: t("aux.messages.alert.error"),
								text: t("aux.messages.alert.text_alert.error_send_file"),
								icon: "error",
							});
							console.error("Error al enviar el archivo:", error);
						});
				}
			});
		}
	};

	const handleFileChange = (event) => {
		const file = event.target.files[0];

		setSelectedFile(file);
		handleFileSelection(file);
	};

	const handleFileSelection = (file) => {
		setSelectedFile(file);
	};

	const handleRadioChange = (event) => {
		const { name } = event.target;
		setChecked(name);
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
			sx={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Box
				sx={{
					width: "40%",
					backgroundColor: "background.paper",
					border: "1px",
					borderRadius: "4px",
					borderColor: "secondary.main",
					boxShadow: 30,
					p: 2,
					overflowY: "auto",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexDirection: "column",
				}}
			>
				<Typography variant="h6" gutterBottom>
					{t("aux.final_adjustments")}
				</Typography>
				<FormControl
					required
					error={!!checkedError}
					component="fieldset"
					sx={{
						width: "100%",
						mb: 2,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					variant="standard"
				>
					<FormGroup>
						<FormLabel component="legend">{t("sim.sim_form.origen_demand")}</FormLabel>
						<FormControlLabel
							control={<Radio checked={checked === "KRONOS"} onChange={handleRadioChange} name="KRONOS" />}
							label="UKG"
						/>
						<FormControlLabel
							control={<Radio checked={checked === "DB"} onChange={handleRadioChange} name="DB" />}
							label={t("sim.sim_form.db")}
						/>
					</FormGroup>
					{checkedError && <FormHelperText>{t("aux.messages.select_checkbox")}</FormHelperText>}
				</FormControl>
				<Grid container spacing={2} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<Grid item xs={6}>
						<TextField
							id="dateInicio"
							label={t("aux.date_start")}
							type="month"
							value={fechaInicio}
							onChange={(e) => setFechaInicio(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							style={{ width: "100%", m: 2 }}
							InputProps={{
								onKeyDown: (e) => {
									e.preventDefault();
								},
							}}
							error={!!fechaError}
							helperText={fechaError && !fechaInicio ? fechaError : ""}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							id="dateFin"
							label={t("aux.date_end")}
							type="month"
							value={fechaFin}
							onChange={(e) => setFechaFin(e.target.value)}
							error={!!fechaError}
							helperText={
								fechaError ? fechaError : fechaInicio > fechaFin ? t("aux.messages.date_error") : ""
							}
							InputLabelProps={{
								shrink: true,
							}}
							style={{ width: "100%" }}
							InputProps={{
								onKeyDown: (e) => {
									e.preventDefault();
								},
							}}
						/>
					</Grid>
					<Grid item xs={12}>
						<Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
							<Button variant="outlined" component="label" sx={{ textTransform: "none" }}>
								{t("file.select")} {/* ← i18n */}
								<input
									hidden
									type="file"
									onChange={handleFileChange}
									// accept="application/pdf,.csv"  // opcional
									// multiple                     // opcional
								/>
							</Button>

							<Typography
								variant="body1"
								sx={{ color: "text.secondary", minWidth: 200, flex: 1 }}
								noWrap
								title={selectedFile ? selectedFile.name : undefined}
							>
								{selectedFile ? selectedFile.name : t("file.none_selected")} {/* ← i18n */}
							</Typography>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<FormNameDesc
							formValues={formValues}
							formErrors={formErrors}
							onFormChange={handleFormChange}
						/>
					</Grid>
					{showAlert && (
						<Grid item xs={12}>
							<Alert severity="error">{t("aux.messages.error_campos")}</Alert>
						</Grid>
					)}
					<Grid item xs={12}>
						<FormControlLabel
							control={
								<Switch
									checked={emailNotifications}
									onChange={(e) => setEmailNotifications(e.target.checked)}
								/>
							}
							label={t("sim.sim_form.email_notify")}
						/>
					</Grid>
					<Grid item xs={12}>
						<Button
							variant="contained"
							color="primary"
							onClick={handleButtonClick}
							sx={{ width: "100%" }}
						>
							{t("aux.buttons.sim.execute")}
						</Button>
					</Grid>
				</Grid>
			</Box>
		</Modal>
	);
};

export { ModalFechaUpload };
